/*
 * POST /api/orders/update-order — App Router handler.
 */
import { NextResponse, type NextRequest } from 'next/server'
import { setRequestLocale } from '../../../common/api/setRequestLocale'
import { routeHandlerWithLogging } from '../../../logging/routeHandlerWithLogging'
import { UPDATE_ORDER_ADAPTERS } from './providers'
import { runUpdateOrder } from './runUpdateOrder'
import { type UpdateOrderHandlerOpts } from './types'

export const updateOrderRouteHandler = (opts?: UpdateOrderHandlerOpts) =>
  routeHandlerWithLogging(async function POST(request: NextRequest) {
    setRequestLocale(request)

    const providerName = opts?.paymentProviderConfig?.providerName ?? 'KLARNA'
    const adapter = UPDATE_ORDER_ADAPTERS[providerName]

    if (!adapter) {
      // todo: add LEDYER
      return NextResponse.json(
        { error: `Not implemented yet: "${providerName}" case` },
        { status: 400 }
      )
    }

    try {
      return await runUpdateOrder(request, adapter)
    } catch (e) {
      return NextResponse.json(
        { error: e instanceof Error ? e.message : 'Unknown error' },
        { status: 400 }
      )
    }
  })
